const FUSE_THRESHOLD = 0.2;

export const OPS_SEARCH_OPTIONS = {
  keys: [
    "op.__typename",
    "pool.assetA.assetId",
    "pool.assetA.assetName",
    "pool.assetA.ticker",
    "pool.assetB.assetId",
    "pool.assetB.assetName",
    "pool.assetB.ticker",
  ],
  threshold: FUSE_THRESHOLD,
};

export const FARMS_SEARCH_OPTIONS = {
  keys: [
    "assetID",
    "pool.assetA.ticker",
    "pool.assetA.assetName",
    "pool.assetA.assetId",
    "pool.assetB.ticker",
    "pool.assetB.assetName",
    "pool.assetB.assetId",
  ],
  threshold: FUSE_THRESHOLD,
};

export const FREEZER_ITEMS_SEARCH_OPTIONS = {
  keys: [
    "data.assetID",
    "data.pool.assetA.ticker",
    "data.pool.assetA.assetName",
    "data.pool.assetA.assetId",
    "data.pool.assetB.ticker",
    "data.pool.assetB.assetName",
    "data.pool.assetB.assetId",
  ],
  threshold: FUSE_THRESHOLD,
};

export const ASSETS_SELECT_FLOW_SEARCH_OPTIONS = {
  keys: [
    "assetA.ticker",
    "assetA.assetName",
    "assetA.assetId",
    "assetB.ticker",
    "assetB.assetName",
    "assetB.assetId",
  ],
  threshold: FUSE_THRESHOLD,
};

export const ASSETS_SEARCH_OPTIONS = {
  keys: ["metadata.ticker", "metadata.assetName", "metadata.assetId"],
  threshold: FUSE_THRESHOLD,
};

export const WITHDRAW_POSITIONS_SEARCH_OPTIONS = {
  keys: [
    "pool.assetA.ticker",
    "pool.assetA.assetName",
    "pool.assetA.assetId",
    "pool.assetB.ticker",
    "pool.assetB.assetName",
    "pool.assetB.assetId",
  ],
  threshold: FUSE_THRESHOLD,
};
